import React from 'react';
import { Button, Modal } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { DashboardUserRole } from '../../common/enums/DashboardUserRole';

interface ChangeRoleDialogProps {
  /** The staff member and the role picked for them; null closes the dialog. */
  change: { name: string; role: DashboardUserRole } | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirms a role change before it is saved (the DeleteConfirmDialog pattern, neutral tone). */
export const ChangeRoleDialog: React.FC<ChangeRoleDialogProps> = ({
  change,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={!!change} onClose={onCancel} size="md">
      <Modal.Header>{t('usersManagement.changeRole.title')}</Modal.Header>
      <Modal.Body>
        <p className="text-gray-700 dark:text-gray-300">
          {change &&
            t('usersManagement.changeRole.message', {
              name: change.name,
              role: t(`roles.${change.role}`),
            })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button gradientMonochrome="success" onClick={onConfirm}>
          {t('usersManagement.changeRole.confirm')}
        </Button>
        <Button color="gray" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
